const base = {
  default: {
    flexWrap: 'wrap',
    height: '100%'
  }
};

const press = {
  default: {
    height: '100%'
  }
};

const container = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    press,
    spark: base
  }
};

export default container;
